<style lang="less" scoped>
    @import "../css/common.less";
    @label_width: 120px;
    .small-card {
        width: 300px;
        display: inline-block;
        margin: 0px 10px 0px 0px;
    }
    .contract-header {
        display: flex;
        flex-wrap:wrap ;
        .middle-card {
            margin: 10px;
            min-width: 400px;
            flex: 3;
        }
        .small-card {
            margin: 10px;
            min-width: 200px;
            flex: 2;
            margin-right: 10px;
        }
        .v-card__title {
            font-size: 1rem;
        }
    }
    .tt-min {
      /deep/ .v-list-item {
        min-height: 30px ;        
      }

    }
    .mr-10 {
      margin-right: 10px;
    }
    .label-width {
        width: 130px;
    }
</style>
<template>
  <div class="container">
    <VProgressLinear
      v-if="get_loading"
      indeterminate
    />
    <div v-if="contract.id">
      <div class="contract-header"> 
        <div class="middle-card">
          <v-card>
            <v-card-title>
              合同详情
            </v-card-title>
            <v-data-table
              dense
              :items-per-page="Infinity"
              :headers="contract_headers"
              :items="contract_list"
              hide-default-footer
            >
              <template
                v-slot:item="{ item }"
              >
                <tr>
                  <td 
                    :style="{'vertical-align':item.value==='desc'?'top':'middle','padding-top':item.value==='desc'?'8px':'' }"
                    class="text-end label-width"
                  >
                    {{ item.type }}
                  </td>
                  <td style="word-break:break-all">
                    <!-- 账单生成方式 -->
                    <span v-if="item.value==='bill_generate_type'">
                      {{ contract.bill_generate_type&&bill_generate_type_lists_hash[contract.bill_generate_type] }}
                    </span>
                    <span v-else-if="item.value==='need_split_expense'">
                      {{ contract.need_split_expense?'是':'否' }}
                    </span>
                    <span v-else-if="item.value==='cost_allocation'">
                      {{ contract.cost_allocation?'是':'否' }}
                    </span>
                    <!-- 账单来源 -->
                    <span v-else-if="item.value==='bill_provider'">
                      <span v-if="contract.bill_generate_type==='self_submit'">
                        {{ bill_provider_types_hash[contract.bill_provider]|| '-' }}
                      </span>
                      <span v-else>-</span>
                    </span>
                    <!-- params.bill_generate_type==='self_submit' -->
                    <span v-else-if="item.value==='total_price'">
                      ￥{{ formatPrice(contract[item.value]) }}
                    </span>
                    <span v-else-if="item.value==='company_team'">
                      {{ company_team }}
                    </span>
                    <span v-else-if="item.value==='uid'">
                      {{ contract.uid }} <span
                        v-if="contract.del"
                        class="color-error"
                      >[<Icon
                        type="trash-a"
                        size="13"
                      /> 已废弃]</span>
                    </span>
                    <span v-else-if="item.value==='contract_nature'">
                      {{ contract_nature_list_hash&&contract_nature_list_hash[contract.contract_nature] }}
                    </span>
                    <span v-else-if="item.value==='is_framework'">
                      {{ contract.is_framework?'是':'否' }}
                    </span>
                    <span v-else-if="item.value==='desc'">
                      <span
                        v-html="contract[item.value]" 
                      /> 
                    </span>
                    <span v-else-if="item.value==='contract_type'">
                      {{ contract_i_e_types_hash[getsafe (contract,'contract_type.balance_type','-')] }}
                    </span>
                    <span v-else-if="item.value==='contract_shuxing'">
                      {{ getsafe (contract,'contract_nature')==='close'?'闭口合同':'开口合同' }}
                    </span>
                    <span v-else-if="item.value==='contract_leibie'">
                      {{ ht_type_infor.ht_lb }}
                    </span>
                    <span v-else-if="item.value==='contract_xiaolei'">
                      {{ ht_type_infor.ht_xl }}
                    </span>
                    <span v-else-if="item.value==='is_czyf'">
                      {{ ht_type_infor.czyf }}
                    </span>
                    <span v-else-if="item.value==='payee_company_account'">
                      {{ getsafe (contract,'payee_company_account.bank') }}
                    </span>
                    <span v-else-if="item.value==='payee_company_account_bank'">
                      {{ getsafe (contract,'payee_company_account.bank_number') }}
                    </span>
                    <!-- payee_company_account -->
                    <span v-else>
                      {{ contract[item.value] || '-' }}
                    </span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </div>    
        <div class="small-card">
          <v-card>
            <v-card-title>
              金额汇总
            </v-card-title>
            <v-data-table
              dense
              :headers="sum_headers"
              :items="sum_list"
              hide-default-footer
            >
              <template
                v-slot:[`item.num_type`]="{ item }"
              >
                {{ getMoney(contract.summations,item.num_type) }}
              </template>
            </v-data-table>
          </v-card>
          <v-card
            v-if="contract.invoice_statistic&&contract.invoice_statistic.length"
            style="margin-top:20px"
          >
            <v-card-title>
              发票汇总
            </v-card-title>
            <v-data-table
              dense
              :headers="invoice_headers"
              :items="contract.invoice_statistic"
              hide-default-footer
            >
              <template
                v-slot:[`item.invoice_type`]="{ item }"
              >
                {{ income_invoice_types_hash[item.invoice_type] }}
              </template>
              <template
                v-slot:[`item.total_amount`]="{ item }"
              >
                {{ getMoney(item,'total_amount') }}
              </template>
            </v-data-table>
          </v-card>
        </div>
        <div
          class="middle-card"
        >
          <v-card>
            <v-card-title>
              合同结算详情
            </v-card-title>
        
            <div class="tt-min">
              <v-list-item>
                <v-list-item-title>
                  合同预计完结时间
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ contract.expect_finish_date || contract.contract_end }}
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item> 
                <v-list-item-title>
                  合同状态
                </v-list-item-title>
                <v-list-item-subtitle>{{ contract.is_closed?'已完结':'未完结' }}</v-list-item-subtitle>
              </v-list-item>
            </div>
           
            <v-data-table
              v-if="!!contract.contract_finish_infos&&contract.contract_finish_infos.length"
              show-expand
              dense
              :headers="settle_accounts_headers"
              :items="contract.contract_finish_infos"
              hide-default-footer
              no-data-text="暂无数据"
            >
              <template v-slot:expanded-item="{ item }">
                <td
                  colspan="4"
                  style="padding:10px;width:100%"
                >
                  {{ item.memo }}
                </td>
              </template>
              <template v-slot:item.is_finish="{ item }">
                {{ item.is_finish?'已完结':'未完结' }}
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}
              </template>
            </v-data-table>
          </v-card>
        </div>
      </div>
      <div
        v-if="!!contract.contract_invoices&&contract.contract_invoices.length"
        style="margin-top: 10px"
      >
        <v-subheader>
          发票信息
        </v-subheader>
        <VTable
          :headers="invoice_infor_headers"
          :desserts="contract.contract_invoices"
        />
      </div>

      <div v-if="!!contract.contract_settlements&&contract.contract_settlements.length">
        <v-subheader>
          合同结算款项
        </v-subheader>
        <VTable
          :headers="js_table_fields"
          :desserts="contract.contract_settlements"
        />
      </div>
      <div
        v-if="!!contract"
        style="margin-top: 10px"
      >
        <Tfjs
          :record="contract"
          :show-add="showTfAdd"
          @addTf="addTf"
        />
      </div>
      <div
        v-if="contract.contract_stocks.length"
        class="line"
      >
        <v-subheader>
          采购订单
        </v-subheader>
        <Table
          :columns="stock_columns"
          :data="contract.contract_stocks"
          size="small"
        />
        <div class="line">
          <v-subheader>
            到货情况
          </v-subheader>
          <StockArrived
            :contract_id="contract.id"
            size="small"
            :show-title="false"
          />
        </div>
      </div>
      <div
        v-if="!!contract.contract_stock_parts&&contract.contract_stock_parts.length"
        class="vuetify"
      >
        <v-subheader>
          配件信息
        </v-subheader>
        <VTable
          :headers="parts_table_fields"
          :desserts="contract.contract_stock_parts"
        />
      </div>
      <div class="line">
        <ExpenseGroupHistory
          relate="contract_id"
          :relate_id="contract.id"
        />
      </div>
      <div class="hr" />
      <div class="line">
        <div class="label">
          关联合同
        </div>
        <div
          v-if="contract.link_contracts.length"
          class="value"
        >
          <div
            v-for="link_contract in contract.link_contracts"
            :key="link_contract.id"
          >
            <ViewerItem
              :model_id="link_contract.id"
              type="Contract"
            >
              <span class="link">{{ link_contract.uid }}</span>
            </ViewerItem>
            <span> - {{ link_contract.name }}</span>
          </div>
        </div>
        <div
          v-else
          class="value"
        >
          无
        </div>
      </div>
      <div class="line">
        <div class="label">
          附件
        </div>
        <div
          v-if="contract.bfiles.length"
          class="value"
        >
          <Attachments :files="contract.bfiles" />
        </div>
        <div
          v-else
          class="value"
        >
          无
        </div>
      </div>
      <div class="line">
        <div class="label">
          合同归档
        </div>
        <div
          v-if="contract.files.length"
          class="value"
        >
          <Attachments :files="contract.files" />
        </div>
        <div
          v-else
          class="value"
        >
          无
        </div>
      </div>
      <div
        v-if="contract.user_flow"
        class="line user-flow"
      >
        <div class="label">
          流程状态
        </div>
        <div class="value">
          <UserFlow :user_flow="contract.user_flow" />
        </div>
      </div>
    </div>
    <!-- <div
      v-else
      class="text-center"
    >
      <Spin
        size="large"
        fix
      />
    </div> -->
  </div>
</template>
<script>
  import ViewerItem from '@/views/components/viewer/item.vue';
  import Attachments from '@/views/components/file/attachments.vue';
  import StockArrived from '@/views/stock/components/stock_arrived.vue';
  import ExpenseGroupHistory from '@/views/expense_group/components/history.vue';
  import { bill_generate_type_lists, bill_provider_types } from '@/views/contract/libs/fields.js'
  import VTable from '@/vuetify_custom/v-table/v1'
  import { VIcon } from 'vuetify/lib'
  import { contract_nature_list_hash } from '@/views/business/fields.js'
  import { contract_i_e_types_hash } from '@/views/components/viewer/components/contract_fields.js'
  import { VProgressLinear } from 'vuetify/lib'
  import {contract_broad_types} from '@/libs/conctract_utils.js'
  import {mapGetters} from "vuex";
  import moment from 'moment'
  import { getsafe } from '@/libs/util.js'
  import { money_collect, money_collect_income } from '@/views/components/viewer/components/contract_fields.js'
  import { INCOME } from '@/views/components/viewer/components/contract_constants.js'
  import Tfjs from './Tfjs'
  const main_type_name_hash = contract_broad_types.hash()
  const invoice_info_hash = {
    normal: '增值税普通发票',
    special: '增值税专用发票',
    'e-normal': '增值税电子普通发票',
    'e-special': '增值税电子专用发票'
  }
  const income_invoice_types_hash = {
    '-1': '未选择',
    '0': '普票',
    '1': '专票'
  }
  export default {
    components: { ViewerItem, Attachments, StockArrived, ExpenseGroupHistory, VTable, VProgressLinear, Tfjs },
    props: {
      model_id: {
        type: Number
      },
      modelId: {
        type: Number
      },
      showTfAdd:{
        type: Boolean
      }
    },
    data() {
      this.contract_i_e_types_hash = contract_i_e_types_hash
      this.moment = moment
      this.contract_nature_list_hash = contract_nature_list_hash
      return {
        get_loading: false,
        contract: {},
        stock_columns_bak:[
          {
            title: '存货',
            align: 'center',
            key: 'uid',
            fix: 'left',
            render: (h, params) => {
              const row = params.row;
              const ret = [
                h(ViewerItem, {
                  props: {
                    model_id: row.stock.id,
                    type: 'Stock'
                  },
                  'class': {
                    'link': true
                  }
                }, row.stock.uid),
                h('div', row.stock.name)
              ];
              return h('div', ret)
            }
          },
          {
            title: '条码/ISBN',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', row.stock.barcode || '-')
            }
          },
          {
            title: '数量/单价',
            align: 'right',
            key: 'qty',
            render: (h, params) => {
              const row = params.row;
              const ret = [
                h('div', `数量: ${Util.formatNumber(row.qty)}`),
                h('div', `单价: ${Util.formatPrice(row.unit_price)}`)
              ];
              return h('div', ret);
            }
          },
          {
            title: '仓库分配',
            align: 'right',
            render: (h, params) => {
              const row = params.row;
              const csws = row.contract_stock_warehouses;
              if (csws && csws.length) {
                const ret = [];
                csws.forEach((csw) => {
                  ret.push(h('div', `${this.getWarehouseName(csw.warehouse_id)}: ${csw.qty}`))
                });
                return h('div', ret);
              } else {
                return h('div', '-');
              }
            }
          },
          {
            title: '总价',
            align: 'right',
            key: 'total_price',
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.total_price));
            }
          },
          {
            title: '预计到货时间',
            align: 'center',
            key: 'estimate_arrival_time',
            render: (h, params) => {
              const row = params.row;
              return h('span', row.estimate_arrival_time || '-');
            }
          }
        ],
        expense_groups_hash: {}
      }
    },
    computed: {
      ht_type_infor() {
        let ht_lb = ''
        const ht_xl = getsafe(this.contract, 'contract_type.sub_type')
        const czyf = getsafe(this.contract, 'is_recharge') === true ? '是' : '否' // is_recharge
        const contract = this.contract
       
        this.contract_types.filter(i => {
          // mian_type_name
 
          const is_same = getsafe(contract, 'contract_type.balance_type') === getsafe(i, 'balance_type', '-') && // 合同类别
            getsafe(contract, 'contract_type.main_type') === getsafe(i, 'main_type', '-')
          if (is_same) {
         
            ht_lb = getsafe(main_type_name_hash, i.main_type, '').title
         
          }
        })
        return {
          ht_lb,
          ht_xl,
          czyf
        }
      },
      model_id_clone() {
        if (this.model_id !== undefined) {
          return this.model_id
        }
        return this.modelId
      },
      js_table_fields() {
        return [
          {
            text: '履约批次',
            align: 'start',
            value: 'index',
            width: 90,
            render: (_, __, index) => {
              return index + 1
            }
          },
          {
            text: '履约时间从',
            align: 'start',
            value: 'start_date',
            width: 100,
          },
          {
            text: '履约时间到',
            align: 'start',
            value: 'end_date',
            width: 100,
          },
          {
            text: '结算方式',
            align: 'start',
            type: 'list_field',
            value: 'settlement_type',
            item_key: 'key',
            item_text: 'title',
            width: 100,
            items: [
              {
                title: '按约定比例',
                key: 'agreement',
              },
              {
                title: '按月',
                key: 'per_month',
              },
              {
                title: '按次',
                key: 'per_time',
              }
            ]
          },
          {
            text: '付款比例（%）',
            align: 'start',
            value: 'settlement_percentage',
            width: 120,
          },
          {
            text: '约定付款时间',
            align: 'start',
            value: 'payment_date',
            width: 110,
          },
          {
            text: '已支付金额',
            align: 'start',
            value: 'have_paid_amount',
            type: 'money_field',
            width: 110,
          },
          {
            text: '本次需支付金额',
            align: 'start',
            value: 'payment_amount',
            type: 'money_field',
            width: 110,
         
          },
          {
            text: '备注',
            align: 'start',
            value: 'desc',
            width: 100,
          },
        ]
      },
      invoice_infor_headers() {
        return [
          {
            text: '发票类型',
            align: 'start',
            value: 'invoice_type',
            renderv:(h, val) => {
              return h('span', {

              }, [invoice_info_hash[val]])
            }
          },
          {
            text: '税率（%）',
            align: 'start',
            value: 'tax_rate',
            render(val) {
              if (!val) {
                return '-'
              }
              return val * 100
            }
          },
          {
            text: '不含税金额',
            align: 'start',
            value: 'excluding_tax',
            type: 'money_field'
          },
          {
            text: '税额',
            align: 'start',
            value: 'tax',
            type: 'money_field'
          },
          {
            text: '数据校验',
            align: 'start',
            value: 'tax_',
            renderv(h, val, target) {
              const is_correct = Math.abs((Number(target.excluding_tax * target.tax_rate).toFixed(2) - Number(target.tax).toFixed(2)).toFixed(2)) <= 0.01
              return is_correct ? h(VIcon, { style:{
                color:"green"
              }, small: true }, 'mdi-check-circle') : h(VIcon, {style:{
                color:"red"
              }, small: true}, 'mdi-alert-circle-outline')
            }
          }
        ]
      },
      bill_generate_type_lists_hash: () => {
       
        return bill_generate_type_lists.reduce((total, item) => {
          total[item.value] = item.label
          return total
        }, {})
      },
      bill_provider_types_hash: () => {
        return bill_provider_types.reduce((total, item) => {
          total[item.value] = item.label
          return total
        }, {})
      },
      income_invoice_types_hash:() => income_invoice_types_hash,

      settle_accounts_headers() {
        return [
          {
            text: '编辑时间',
            align: 'center',
            sortable: false,
            value: 'created_at',
          },
          // {
          //   text: '说明',
          //   sortable: false,
          //   value: 'memo',
          // },
          {
            text: '状态',
            sortable: false,
            value: 'is_finish',
          },
          {
            text: '负责人',
            align: 'end',
            sortable: false,
            value: 'customer_name',
          }
        ]
      },
      sum_headers() {
        return [
          {
            text: '类别',
            align: 'center',
            sortable: false,
            value: 'type',
          },
          {
            text: '金额',
            align: 'end',
            sortable: false,
            value: 'num_type',
          }
        ]
      },
      sum_list() {
        // income INCOME
        const is_virtual = getsafe(this.contract, 'is_virtual', false)
        const is_income = getsafe(this.contract, 'contract_type.balance_type', '') === INCOME
        if (is_income && !is_virtual) {
          return money_collect_income
        }
        return money_collect
      },
      contract_headers() {
        return [
          {
            text: '类别',
            align: 'end',
            sortable: false,
            value: 'type',
          },
          {
            text: '值',
            align: 'start',
            sortable: false,
            value: 'value',
          }
        ]
      },
      contract_list() {

        const arr = [
          {
            type: '合同编号',
            value: 'uid'
          },
          {
            type: '合同收支',
            value: 'contract_type'
          },
          {
            type: '合同属性',
            value: 'contract_shuxing'
          },
          {
            type: '合同类别',
            value: 'contract_leibie'
          },
          {
            type: '合同小类',
            value: 'contract_xiaolei'
          },
          {
            type: '是否是框架协议',
            value: 'is_framework'
          },
          {
            type: '是否需充值预付',
            value: 'is_czyf'
          },
          {
            type: '合同名称',
            value: 'name'
          }, 
          {
            type: '申请人',
            value: 'apply_user'
          },
          {
            type: '公司|团队',
            value: 'company_team'
          },
          {
            type: '合同总金额',
            value: 'total_price'
          },
          {
            type: '对方名称',
            value: 'payee_company'
          },
          {
            type: '对方开户行',
            value: 'payee_company_account'
          },
          {
            type: '对方银行账号',
            value: 'payee_company_account_bank'
          },
          {
            type: '账单生成方式',
            value: 'bill_generate_type'
          },

          {
            type: '是否需拆分费用',
            value: 'need_split_expense'
          },
          {
            type: '是否摊销',
            value: 'cost_allocation'
          },
          {
            type: '账单来源',
            value: 'bill_provider'
          },
         
          {
            type: '生效日期',
            value: 'contract_start'
          },
          {
            type: '终止日期',
            value: 'contract_end'
          },
         
          {
            type: '备注',
            value: 'desc'
          }
        ]
        return arr.filter(item => {
          return item.value !== 'bill_provider' || this.contract.bill_generate_type === 'self_submit'
        })
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        warehouses_hash: 'async/warehouses_hash',
        contract_types: 'async/contract_types',
      }),
      company() {
        const company = this.companies_hash[this.contract.company_id];
        return company ? company.short_name : '-';
      },
      team() {
        const team = this.teams_hash[this.contract.team_id];
        return team ? team.name : '-';
      },
      company_team() {
        return `${this.company} | ${this.team}`;
      },
      parts_table_fields() {
        return [
          {
            text: '配件代码',
            align: 'start',
            value: 'uid',
            render(_, target) {
              return target.stock.uid
            }
            
          },
          {
            text: '配件名称',
            align: 'start',
            value: 'name',
            render(_, target) {
              return target.stock.name
            }
          }, {
            text: '采购数量',
            type: 'money_field',
            align: 'start',
            value: 'qty',
          }, {
            text: '采购单价',
            type: 'money_field',
            align: 'start',
            value: 'unit_price'
            // render:(h, {row}) => {
            //   return h('span', {}, '测试')
            // }
          }, {
            text: '采购总价',
            type: 'money_field',
            align: 'start',
            value: 'total_price',
            
          }, {
            text: '配件用量',
            type: 'money_field',
            value: 'unit_qty',
            align: 'start',
          }, {
            text: '备注',
            align: 'start',
            value: 'remarks',
            
          },
        ]
      },
      stock_columns() {
        const columns = [
          {
            title: '存货',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              const ret = [
                h(ViewerItem, {
                  props: {
                    model_id: row.stock.id,
                    type: 'Stock'
                  },
                  'class': {
                    'link': true
                  }
                }, row.stock.uid),
                h('div', row.stock.name)
              ];
              return h('div', ret)
            }
          },
          {
            title: '条码/ISBN',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const stock = params.row.stock;
              return h('div', stock.barcode || '-')
            }
          },

        ];
        if (this.contract.bill_type === 'OutSourcing') {
          columns.push({
            title: '入库类型',
            align: 'center',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              if (row.stock_in_type === 'need') {
                return h('div', {
                  'class':{
                    'color-success': true
                  }
                }, '需要入库');
              } else if (row.stock_in_type === 'none') {
                return h('div', {
                  'class':{
                    'color-grey': true
                  }
                }, '无需入库');
              }
              return h('div', '-');
            }
          },)
        }
        return columns.concat([
          {
            title: '采购数量',
            align: 'right',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              return h('span', Util.formatNumber(row.qty));
            }
          },
          {
            title: '到货数量',
            align: 'right',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              return h('span', Util.formatNumber(row.arrived_qty));
            }
          },
          {
            title: '剩余数量',
            align: 'right',
            width: 60,
            render: (h, params) => {
              const row = params.row;
              return h('span', Util.formatNumber(math.eval(`${row.qty} - ${row.arrived_qty}`).toFixed(2)));
            }
          },
          {
            title: '采购单价',
            align: 'right',
            width: 60,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.unit_price));
            }
          },
          {
            title: '仓库分配',
            align: 'right',
            width: 150,
            render: (h, params) => {
              const row = params.row;
              const csws = row.contract_stock_warehouses;
              if (csws && csws.length) {
                const ret = [];
                csws.forEach((csw) => {
                  ret.push(h('div', `${this.getWarehouseName(csw.warehouse_id)}: ${csw.qty}`))
                });
                return h('div', ret);
              } else {
                return h('div', '-');
              }
            }
          },
          {
            title: `总价 ${this.$util.formatPrice(this.contract.stock_total_price)}`,
            align: 'right',
            key: 'total_price',
            minWidth: 100,
            render: (h, params) => {
              return h('div', Util.formatPrice(params.row.total_price));
            }
          },
          {
            title: '预计到货时间',
            align: 'center',
            key: 'estimate_arrival_time',
            minWidth: 100,
            render: (h, params) => {
              const row = params.row;
              return h('span', row.estimate_arrival_time || '-');
            }
          },
          {
            title: '最佳采购量测算',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              const row = params.row;
              return h(ViewerItem, {
                props: {
                  type: 'StockCalculator',
                  model_id: row.stock.id,
                  tip: false
                },
              }, [h('Button', {
                props: {size: 'small'}
              }, '测算')]);
            }
          },
          {
            title: '链接',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              const row = params.row;
              const url = getsafe(row, 'stock_price.enquiry_url')
              if (!url) {
                return h('span', ['-'])
              }
              return h('Button', {
                props: {size: 'small', type: 'text'},
                on: {
                  click: () => {
                    const t = /^http(s)?:/
                    if (t.test(url)) {
                      window.open(url, '__blank')
                    } else {
                      window.open(`https://${url}`, '__blank')
                    }
                  }
                }
              }, '🔗');
            }
          },
          {
            title: '备注',
            align: 'center',
            minWidth: 100,
            key: 'remarks'
          }
        ])
      }
    },
    created() {
   
    },
    mounted() {
      this.getContract();
      //
    },
    methods: {
      getsafe(...arg) {
        return getsafe(...arg)
      },
      addTf(...params) {
        this.$emit('addTf', ...params)
      },
      getTotal(placing_ads_records) {
        placing_ads_records = placing_ads_records || []
        let total = 0
        placing_ads_records.forEach(i => {
          total = math.eval(`${total}+${i.total_price}`)
        })
        total = total.toNumber && total.toNumber() || 0
        return Util.formattingNumber(total, 2) 
      },
      getMoney(target, key) {
        if (!target) {
          target = {}
        }
        const num = target[key] || 0
        return this.$util.formattingNumber(Number(num), 2)
      },
      getContract() {
        this.get_loading = true
        Util.ajax.get(Util.api.contract_detail, {
          params: {
            id: this.model_id_clone
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.contract = res.data.contract;
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.error({
            title: '错误',
            content: e.message
          });
        }).finally(() => {
          this.get_loading = false
        });
      },
      formatPrice(price) {
        return Util.formatPrice(price);
      },
      getWarehouseName(id) {
        const wh = this.warehouses_hash[id];
        return wh ? wh.name : '未定义仓库';
      }
    }
  }
</script>
